import { useState } from 'react';

export const Select = (props) => {
    const { name, value } = props;
    const [newValue, setNewValue] = useState(value);
    const choosers = props.choosers ? props.choosers : [];
    return (
        <div className="row">
            <label className="label" htmlFor={name}>{name}</label>
            <select className="select" name={name} id={name} value={newValue} onChange={(e) => { setNewValue(e.target.value); }}>
                <option value="0">-- choose option --</option>
                {choosers.map((el, i) => {
                    return (
                        <option value={el.id} key={i}>{el.name}</option>
                    )
                })}
            </select>
        </div>
    )
}